import { withStyles } from '@material-ui/core/styles';
import 'moment-timezone';
import moment from 'moment';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Spinner } from 'react-activity';
import DatePicker from 'react-datepicker';
import Headers from './Header';
import Availabilty from './Availability';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import { showNotification } from '../../action/NotificationAction';
import {
    addAvailability,
    deleteAvail,
    getAvailList,
} from '../../action/educator/AvailablityAction';
import { PATH } from '../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import {
    addCustomAvailability,
    deleteCustomAvail,
    getCustomAvailList,
} from '../../action/educator/CustomAvailablity';

const styles = (theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
});

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class PhysicianManageSchedule extends Component {
    static propTypes = {
        showNotification: PropTypes.func,
        getAvailList: PropTypes.func,
        deleteAvail: PropTypes.func,
        addAvailability: PropTypes.func,
        getCustomAvailList: PropTypes.func,
        addCustomAvailability: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoadingAvailList: false,
            cancelAvailabilityIsOpen: false,
            isOndemand: false,
            isTabName: 'manage',
            selectedStartDate: null,
            selectedEndDate: null,
            availabilityDays: [
                { availabilityId: 1, availabilityDay: 'Sunday', isChecked: false },
                { availabilityId: 2, availabilityDay: 'Monday', isChecked: false },
                { availabilityId: 3, availabilityDay: 'Tuesday', isChecked: false },
                { availabilityId: 4, availabilityDay: 'Wednesday', isChecked: false },
                { availabilityId: 5, availabilityDay: 'Thursday', isChecked: false },
                { availabilityId: 6, availabilityDay: 'Friday', isChecked: false },
                { availabilityId: 7, availabilityDay: 'Saturday', isChecked: false },
            ],
            timeZone: null,
            availabilityTimes: [],
            from_time: '',
            to_time: '',
            Submit: 'Save',
            modalTitle: '',
            scheduleId: '',
            endTimee: '',
            startTimee: '',
            isStartFilled: false,
            isEndFilled: false,
            isLoading: false,
            timezoneName: '',
        };
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.setState({ isLoadingAvailList: true }, () => {
            this.loadAvailList();
        });
        const d = new Date();
        this.setState({
            timezoneName: moment
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .zoneAbbr(d.getTimezoneOffset()),
        });
    }

    //loadAvailList
    loadAvailList = () => {
        if (this.state.isTabName === 'custom') {
            this.props.getCustomAvailList(null, (response) => {
                if (response && response.length) {
                    this.setState({
                        customAvailTiming: response,
                        isLoadingAvailList: false,
                    });
                } else {
                    this.setState({
                        customAvailTiming: [],
                        isLoadingAvailList: false,
                    });
                }
            });
        } else {
            this.props.getAvailList(null, (response) => {
                if (response && response.length) {
                    this.setState({
                        availTiming: response,
                        isLoadingAvailList: false,
                    });
                } else {
                    this.setState({
                        availTiming: [],
                        isLoadingAvailList: false,
                    });
                }
            });
        }
    };

    //deleteAvail
    deleteAvail = (scheduleId) => {
        const { isTabName } = this.state;
        this.setState({ isLoadingAvailList: true }, () => {
            if (isTabName === 'manage') {
                // Call deleteAvail API
                this.props.deleteAvail(scheduleId, (response) => {
                    if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                        this.loadAvailList();
                    } else {
                        if (response.message) {
                            this.props.showNotification(
                                response.message,
                                RESPONSE_CONSTANT.WARNING
                            );
                            this.setState({ isLoadingAvailList: false });
                        }
                    }
                });
            } else {
                // Call deleteCustomAvail API
                this.props.deleteCustomAvail(scheduleId, (response) => {
                    if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                        this.loadAvailList();
                    } else {
                        if (response.message) {
                            this.props.showNotification(
                                response.message,
                                RESPONSE_CONSTANT.WARNING
                            );
                            this.setState({ isLoadingAvailList: false });
                        }
                    }
                });
            }
        });
    };

    //handleCheckChieldElement
    handleCheckChieldElement = (event) => {
        let availabilityDayNew = this.state.availabilityDays;
        availabilityDayNew.forEach((avail) => {
            if (avail.availabilityDay === event.target.value)
                avail.isChecked = event.target.checked;
        });
        this.setState({ availabilityDays: availabilityDayNew });
    };

    //handleStartTime
    handleStartTime = (event) => {
        const date = new Date();
        const dateAsString = date.toString();
        const timeZone = moment.tz(dateAsString).zoneAbbr();
        this.setState({ timeZone: timeZone, startTimee: event.target.value });
        if (event.target.value !== '') {
            this.setState({ isStartFilled: true });
        } else {
            this.setState({ isStartFilled: false });
        }
    };

    //handleEndTime
    handleEndTime = (event) => {
        const date = new Date();
        const dateAsString = date.toString();
        const timeZone = moment.tz(dateAsString).zoneAbbr();
        this.setState({ timeZone: timeZone, endTimee: event.target.value });
        if (event.target.value !== '') {
            this.setState({ isEndFilled: true });
        } else {
            this.setState({ isEndFilled: false });
        }
    };

    //handleStartDateChange
    handleStartDateChange = (date) => {
        const { selectedEndDate } = this.state;
        const selectedStartDate = moment(date);
        if (selectedEndDate && selectedStartDate.isAfter(selectedEndDate)) {
            this.props.showNotification(
                'Start date cannot be greater than end date.',
                RESPONSE_CONSTANT.WARNING
            );
        } else {
            this.setState({ selectedStartDate: date });
        }
    };

    //handleEndDateChange
    handleEndDateChange = (date) => {
        const { selectedStartDate } = this.state;
        const selectedEndDate = moment(date);
        if (selectedStartDate && selectedEndDate.isBefore(selectedStartDate)) {
            this.props.showNotification(
                'End date cannot be less than start date.',
                RESPONSE_CONSTANT.WARNING
            );
        } else {
            this.setState({ selectedEndDate: date });
        }
    };

    //availSave
    availSave = () => {
        const { availabilityDays, selectedStartDate, selectedEndDate, isTabName } = this.state;
        const formattedStartDate = moment(selectedStartDate);
        const formattedEndDate = moment(selectedEndDate);
        if (isTabName === 'custom') {
            if (!selectedStartDate || !selectedEndDate) {
                this.props.showNotification(
                    'Please select both start and end dates.',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (this.state.startTimee === '' || this.state.endTimee === '') {
                this.props.showNotification(
                    'Please select both start and end times.',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            let startTime = moment(this.state.startTimee, 'HH:mm');
            let endTime = moment(this.state.endTimee, 'HH:mm');
            if (endTime.isBefore(startTime)) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.END_TIME_LESS_THAN_START_TIME,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (this.state.startTimee === this.state.endTimee) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.START_AND_END_TIME_NOT_SAME,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (endTime.diff(startTime, 'minutes') < 15) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.MINUMUM_SLOT_DURATION,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            this.setState({ isLoading: true });
            const values = {
                startDate: formattedStartDate.format('YYYY-MM-DD'),
                endDate: formattedEndDate.format('YYYY-MM-DD'),
                startTime: this.state.startTimee,
                endTime: this.state.endTimee,
                onDemandAccept: this.state.isOndemand,
            };
            this.props.addCustomAvailability(values, (response) => {
                this.setState({ isLoading: false });
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                    this.setState({ isTabName: 'custom' });
                    this.loadAvailList();
                    this.closeAvailabilityModal();
                    this.setState({ cancelAvailabilityIsOpen: false });
                } else {
                    if (response.message) {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                    }
                }
            });
            return;
        }
        if (availabilityDays && availabilityDays.length) {
            var avail = [];
            availabilityDays.forEach((response) => {
                if (response.isChecked) {
                    avail.push(response.availabilityId);
                }
            });
            if (avail.length) {
                var availTime = {};
                var availabilityTime = [];
                availTime['startTime'] = this.state.startTimee + ':00';
                availTime['endTime'] = this.state.endTimee + ':00';
                availabilityTime.push(availTime);
                if (this.state.startTimee === RESPONSE_CONSTANT.EMPTY) {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.START_TIME_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                if (this.state.endTimee === RESPONSE_CONSTANT.EMPTY) {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.END_TIME_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                if (this.state.startTimee !== '' && this.state.endTimee !== '') {
                    let startTime = moment(availTime['startTime'], 'hh:mm:ss a');
                    let endTime = moment(availTime['endTime'], 'hh:mm:ss a');
                    if (this.state.startTimee === this.state.endTimee) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.START_AND_END_TIME_NOT_SAME,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    if (endTime.isBefore(startTime)) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.END_TIME_LESS_THAN_START_TIME,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    if (endTime.diff(startTime, 'minutes') < 15) {
                        this.props.showNotification(
                            RESPONSE_CONSTANT.MINUMUM_SLOT_DURATION,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    this.setState({ isLoading: true });
                    const values = {
                        availableDays: avail,
                        availableTimes: availabilityTime,
                        onDemandAccepted: this.state.isOndemand,
                    };
                    this.props.addAvailability(values, (response) => {
                        this.setState({ isLoading: false });
                        if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                            this.props.showNotification(
                                response.message,
                                RESPONSE_CONSTANT.SUCCESS
                            );
                            this.loadAvailList();
                            this.setState({ cancelAvailabilityIsOpen: false });
                        } else {
                            if (response.message) {
                                this.props.showNotification(
                                    response.message,
                                    RESPONSE_CONSTANT.ERROR
                                );
                            }
                        }
                    });
                }
            } else {
                if (isTabName === 'manage') {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.DAY_MANDATORY,
                        RESPONSE_CONSTANT.WARNING
                    );
                }
                return;
            }
        }
    };

    //openAvailModal
    openAvailModal = () => {
        this.setState({
            isStartFilled: false,
            isEndFilled: false,
            startTimee: '',
            endTimee: '',
        });
        const { availabilityDays } = this.state;
        availabilityDays.forEach((response) => {
            response.isChecked = false;
        });
        this.setState({
            cancelAvailabilityIsOpen: true,
            availabilityTimes: [],
            availabilityDays,
            modalTitle: this.state.isTabName === 'manage' ? 'Add Schedule' : 'Custom Schedule',
            Submit: 'Save',
            scheduleId: '',
            isLoading: false,
            isOndemand: false,
        });
    };

    //openAvailalibiltyModal
    openAvailalibiltyModal = () => {
        const { cancelAvailabilityIsOpen, availabilityTimes, modalTitle } = this.state;
        return (
            <Modal
                overlayClassName={'modal-background z-index-1'}
                isOpen={cancelAvailabilityIsOpen}
                onRequestClose={this.closeAvailabilityModal}
                className={'modal-width'}
                contentLabel="Example"
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-schedule">
                        <div className="flex items-start justify-between">
                            <h6 className="mt-0 mb-5 text-lg font-medium text-white">
                                {modalTitle}
                            </h6>
                            <button type="button" onClick={() => this.closeAvailabilityModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-center gap-2">
                            <input
                                onChange={() => {
                                    this.setState({ isOndemand: !this.state.isOndemand });
                                }}
                                checked={this.state.isOndemand}
                                type="checkbox"
                                className=""
                            />
                            <label htmlFor="select-subject" className="m-0 text-base text-white">
                                Available for On-demand
                            </label>
                        </div>
                        {this.state.isTabName === 'manage' && (
                            <div className="grid gap-4 mt-8 sm:grid-cols-4">
                                {this.state.availabilityDays &&
                                    this.state.availabilityDays.map((avail) => (
                                        <div
                                            key={avail.availabilityId}
                                            className="flex items-center gap-2 text-white"
                                        >
                                            <label>
                                                <input
                                                    key={avail.availabilityId}
                                                    onChange={this.handleCheckChieldElement}
                                                    type="checkbox"
                                                    checked={avail.isChecked}
                                                    value={avail.availabilityDay}
                                                />{' '}
                                                <span>{avail.availabilityDay}</span>
                                            </label>
                                        </div>
                                    ))}
                            </div>
                        )}
                        {this.state.isTabName === 'custom' && (
                            <>
                                <div className="grid gap-8 mt-6 sm:grid-cols-2">
                                    <div className="inputgroup">
                                        <label
                                            htmlFor="select-date"
                                            className="block mt-6 mb-2 text-base font-normal text-white rounded"
                                        >
                                            Start Date
                                        </label>
                                        <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                            <div className="flex w-full mb-2 rounded border-black-10">
                                                <div className="grow">
                                                    <DatePicker
                                                        name="start-date"
                                                        className="w-full px-2 text-base text-white placeholder:text-secondary datepicker-opacity example-custom-input"
                                                        wrapperClassName={'w-full'}
                                                        placeholderText="Select start date"
                                                        selected={this.state.selectedStartDate}
                                                        onChange={this.handleStartDateChange}
                                                        dropdownMode="select"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        maxDate={
                                                            new Date(
                                                                moment(new Date()).add(6, 'months')
                                                            )
                                                        }
                                                        minDate={new Date()}
                                                        autoComplete="off"
                                                        filterDate={(date) =>
                                                            this.state.availabilityDays.some(
                                                                (day) =>
                                                                    day.isChecked &&
                                                                    moment(date)
                                                                        .format('dddd')
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            day.availabilityDay.toLowerCase()
                                                                        )
                                                            ) ||
                                                            !this.state.availabilityDays.some(
                                                                (day) => day.isChecked
                                                            )
                                                        }
                                                        popperPlacement="right-start"
                                                        popperModifiers={[
                                                            {
                                                                name: 'offset',
                                                                options: {
                                                                    offset: [10, 10],
                                                                },
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inputgroup">
                                        <label
                                            htmlFor="select-date"
                                            className="block mt-6 mb-2 text-base font-normal text-white rounded"
                                        >
                                            End Date
                                        </label>
                                        <div className="relative flex flex-wrap items-stretch w-full mb-0">
                                            <div className="flex w-full mb-2 rounded border-black-10">
                                                <div className="grow">
                                                    <DatePicker
                                                        name="end-date"
                                                        className="w-full px-2 text-base text-white placeholder:text-secondary datepicker-opacity example-custom-input"
                                                        wrapperClassName={'w-full'}
                                                        placeholderText="Select end date"
                                                        selected={this.state.selectedEndDate}
                                                        onChange={this.handleEndDateChange}
                                                        dropdownMode="select"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        maxDate={
                                                            new Date(
                                                                moment(new Date()).add(6, 'months')
                                                            )
                                                        }
                                                        minDate={new Date()}
                                                        autoComplete="off"
                                                        filterDate={(date) =>
                                                            this.state.availabilityDays.some(
                                                                (day) =>
                                                                    day.isChecked &&
                                                                    moment(date)
                                                                        .format('dddd')
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            day.availabilityDay.toLowerCase()
                                                                        )
                                                            ) ||
                                                            !this.state.availabilityDays.some(
                                                                (day) => day.isChecked
                                                            )
                                                        }
                                                        popperPlacement="left-start"
                                                        popperModifiers={[
                                                            {
                                                                name: 'offset',
                                                                options: {
                                                                    offset: [10, 10],
                                                                },
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="grid gap-8 mt-8 sm:grid-cols-2">
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-white"
                                >
                                    Start Time
                                </label>
                                <div className="flex w-full mb-2 rounded">
                                    <input
                                        id="time"
                                        label="Start Time"
                                        name="from_time"
                                        type="time"
                                        className="w-full p-1.5 bg-card text-white placeholder:text-secondary text-base rounded"
                                        defaultValue={
                                            availabilityTimes && availabilityTimes.length
                                                ? availabilityTimes[0].startTime
                                                : ''
                                        }
                                        onChange={(event) => this.handleStartTime(event)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="time"
                                    className="block mb-2 text-base font-normal leading-6 text-white"
                                >
                                    End Time
                                </label>
                                <div className="flex w-full mb-2 rounded border-black-10">
                                    <input
                                        id="time"
                                        label="End Time"
                                        type="time"
                                        name="to_time"
                                        className="w-full p-1.5 bg-card text-white placeholder:text-secondary text-base rounded"
                                        defaultValue={
                                            availabilityTimes && availabilityTimes.length
                                                ? availabilityTimes[0].endTime
                                                : ''
                                        }
                                        onChange={(event) => this.handleEndTime(event)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center justify-end mt-6 space-x-4">
                            <button
                                data-modal-hide="defaultModal"
                                type="button"
                                className="text-white bg-black rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.closeAvailabilityModal}
                            >
                                Cancel
                            </button>
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-UIprimary rounded-lg font-semibold text-base sm:w-3/12 w-full py-1.5"
                                onClick={this.availSave}
                                disabled={this.state.isLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.state.isLoading ? <Spinner color="#FFF" /> : 'Save'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //closeAvailabilityModal
    closeAvailabilityModal = () => {
        this.setState({
            cancelAvailabilityIsOpen: false,
        });
        this.setState({
            startTimee: '',
            endTimee: '',
            selectedStartDate: '',
            selectedEndDate: '',
        });
    };

    /**
     *
     * Render page
     */
    render() {
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.MANAGE_SCHEDULE}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow overflow-auto">
                    <Headers
                        {...this.props}
                        title="Manage Schedule"
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="flex items-center justify-between px-4 sm:px-8">
                            <div className="px-4">
                                <nav className="flex flex-col gap-4 sm:flex-row">
                                    <button
                                        className={
                                            this.state.isTabName === 'manage'
                                                ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-emerald focus:outline-none border-b-2 border-emerald'
                                                : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none'
                                        }
                                        onClick={() => {
                                            this.setState({ isTabName: 'manage' }, () => {
                                                this.loadAvailList();
                                            });
                                        }}
                                    >
                                        Reoccurring Weekly Schedule
                                    </button>
                                    <button
                                        className={
                                            this.state.isTabName === 'custom'
                                                ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-emerald focus:outline-none border-b-2 border-emerald'
                                                : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none'
                                        }
                                        onClick={() => {
                                            this.setState({ isTabName: 'custom' }, () => {
                                                this.loadAvailList();
                                            });
                                        }}
                                    >
                                        Custom Schedule
                                    </button>
                                </nav>
                            </div>
                            <div
                                className={`flex gap-4 justify-end ${
                                    this.state.customSelect ? 'lg:w-2/8' : 'lg:w-2/6'
                                }`}
                            >
                                <button
                                    className="bg-UIprimary p-3 py-1.5 rounded-lg text-white font-semibold whitespace-nowrap"
                                    onClick={this.openAvailModal}
                                >
                                    {this.state.isTabName === 'manage'
                                        ? ' Add Schedule'
                                        : 'Custom Schedule'}
                                </button>
                            </div>
                        </div>
                        {this.state.isLoadingAvailList ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                                    <div className="overflow-x-auto rounded-lg border-black-10">
                                        {this.openAvailalibiltyModal()}
                                        <Availabilty
                                            availTiming={
                                                this.state.isTabName === 'manage'
                                                    ? this.state.availTiming
                                                    : []
                                            }
                                            customAvailTiming={
                                                this.state.isTabName === 'custom'
                                                    ? this.state.customAvailTiming
                                                    : []
                                            }
                                            deleteAvail={this.deleteAvail}
                                            isLoadingAvailList={this.state.isLoadingAvailList}
                                            loadAvailList={this.loadAvailList}
                                            timezoneName={this.state.timezoneName}
                                            isTabName={this.state.isTabName}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getAvailList: (value, type) => {
            dispatch(getAvailList(value, type));
        },
        getCustomAvailList: (value, type) => {
            dispatch(getCustomAvailList(value, type));
        },
        deleteAvail: (value, type) => {
            dispatch(deleteAvail(value, type));
        },
        deleteCustomAvail: (value, type) => {
            dispatch(deleteCustomAvail(value, type));
        },
        addAvailability: (value, type) => {
            dispatch(addAvailability(value, type));
        },
        addCustomAvailability: (value, type) => {
            dispatch(addCustomAvailability(value, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(PhysicianManageSchedule));
